import { render } from "./ListagemDeAnexosCadastro.vue?vue&type=template&id=687fa39a&scoped=true"
import script from "./ListagemDeAnexosCadastro.vue?vue&type=script&lang=js"
export * from "./ListagemDeAnexosCadastro.vue?vue&type=script&lang=js"

import "./ListagemDeAnexosCadastro.vue?vue&type=style&index=0&id=687fa39a&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687fa39a"],['__file',"src/views/Legalize/CadastroDeProcessos/Components/ListagemDeAnexosCadastro.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "687fa39a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('687fa39a', __exports__)) {
    console.log('reload')
    api.reload('687fa39a', __exports__)
  }
  
  module.hot.accept("./ListagemDeAnexosCadastro.vue?vue&type=template&id=687fa39a&scoped=true", () => {
    console.log('re-render')
    api.rerender('687fa39a', render)
  })

}


export default __exports__